/* eslint-disable */

import React, {useEffect, useState, useLocation} from 'react'

// Services
import waTemplateSvc from "services/waTemplateSvc";
import applicationSvc from "services/applicationSvc";

// component
import TitleV2 from 'components/TitleV2';
import Wrapper from './Wrapper';
// import ButtonGenerate from './ButtonGenerate';
import Table from './TableData';
import FilterTable from './filter-table';
import OnBoarding from './CreateTemplate/index';

// library 
import moment from "moment";
import { Route, Switch, useHistory } from "react-router-dom";

// style
import '../../_assets/style/helper.scss';
import styled from 'styled-components';


function WhatsappTemplate() {
  // const location = useLocation();
  // console.log('location',location)
  const history = useHistory();

  const [isLoadingGetList, setLoadingGetList] = useState(false)
  const [isDataUser, listDataUser] = useState([]);
  const [isPagination, setPagination]=useState({});
  const [rangeDate, setRangeDate] = useState([new Date(), new Date()]);
  const startDateData = moment(rangeDate[0] || rangeDate?.start).format("YYYY-MM-DD");
  const endDateData = moment(rangeDate[1] || rangeDate?.end).format("YYYY-MM-DD");
  const [isSearch, setSearch] = useState('');
  const [timer, setTimer] = useState(null)
  const [isListStatus, setListStatus] = useState([]);
  const [isUpdatedChange, setUpdatedChange] = useState(false);
  const [filter, setFilter] = useState (
    {
      "application_id": [],
      "channel": [],
      "start_date": startDateData,
      "end_date": endDateData,
      "type": [],
      "search": "",
      "limit": 10,
      "page": 1,
      "status":'all'
    }
  )
  const [isModalAddTemplate, setModalAddTemplate]=useState({show: false, payload: ''});


  useEffect(() => {
    setListStatus([
      // {
      //   name:'All',
      //   value:'all',
      // },
      {
        name:'Draft',
        value:'Draft',
      },
      {
        name:'In Review',
        value:'Reviewed',
      },
      {
        name:'Requested',
        value:'Requested',
      },
      {
        name:'Approved',
        value:'Approved',
      },
      {
        name:'Rejected',
        value:'Rejected',
      },
    ])
  }, [])

useEffect(()=>{
  getAllData();
},[])

const handleAddTemplate = () =>{
  setModalAddTemplate({show: true, payload: ''})
}

  // INTEGRATION
async function getAllData() {
  // setLoadingGetList(true)
  let res = await applicationSvc.getAll()
  
  if(res.data.data){
    let newFilter = filter;
    let data = []
    res?.data?.data.forEach(element => {
      data.push(element._id)
    });
    newFilter.application_id = data;
    setFilter(newFilter)
    handleListReport();
  }
};

  useEffect( () => {
    delayedQuery()
    console.log('filter kuhehe',filter)
  }, [isUpdatedChange]);
  
   async function handleListReport(){
     listDataUser([])
     setLoadingGetList(true)
     if(filter.status && filter.application_id.length > 0){
       await waTemplateSvc.getListTemplate(filter)
       .then((res)=>{
        listDataUser(res.data.data.docs)
        
        // listDataUser(
        //   res.data.data.map(res=>{
        //     res.checked = false;
        //     return res;
        //   })
        // )
        let paginate = {
         page : res.data?.data.page,
        //  limit : res.data?.data.limit,
         pages : res.data?.data.pages,
         total_all : res.data?.data.total,
        }
    
        setPagination(paginate)
        setLoadingGetList(false)
       })
       .catch((error)=>{
        console.log(error)
        setLoadingGetList(false)
       })
     }
  }

  
  function changeCriteriaPaginationBar(data){
    const newFilter=filter
    newFilter.page = data.page;
    newFilter.limit = data.limit;
    setFilter(newFilter);
    handleListReport();
  }
  

  
  const delayedQuery = async () => {
    const newFilter=filter;
    newFilter.search=isSearch;
    newFilter.page=1;
    setFilter(newFilter);
    
    clearTimeout(timer)
    
    const newTimer = setTimeout(async() => {
      setLoadingGetList(true);
      await handleListReport();
      setLoadingGetList(false);
    }, 500)
  
    setTimer(newTimer)
  }


  return (
    <Wrapper className="d-flex flex-column container-fluid no-pad wa-template-scroll" style={{height:'100%'}}>
      <OnBoarding
        isModalAddTemplate={isModalAddTemplate}
        setModalAddTemplate={setModalAddTemplate}
      />
      <div className="d-flex flex-row align-items-start justify-content-between margin-bottom-20">
        <div className="d-flex flex-column">
          <TitleV2>Whatsapp Template</TitleV2>
        </div>
          <div onClick={handleAddTemplate} className='mb-2 btn-generate-report'>
            <h5 className="fw-bold btn-generate">
              Add Template
            </h5>
          </div>
      </div>
      <div className="d-flex flex-row justify-content-between align-items-center">
      <div className="d-flex flex-row align-items-center w-100">
       <FilterTable 
        isPagination={isPagination} 
        changeCriteria={changeCriteriaPaginationBar}
        searchKey={setSearch} 
        setUpdatedChange={setUpdatedChange} 
        isUpdatedChange={isUpdatedChange} 
        isListStatus={isListStatus} 
        isFilter={filter} 
        setFilter={setFilter}></FilterTable>
      </div>
    </div>
    <Table handleListReport={handleListReport} isDataUser={isDataUser} isLoadingGetList={isLoadingGetList} isPagination={isPagination} changeCriteria={changeCriteriaPaginationBar}/>
    </Wrapper>
  )
}

export default WhatsappTemplate;